<template>
  <v-card
      outlined
  >
    <v-list-item
        dark
        :class="step.complete ? 'success' : step.error ? 'error' : 'grey'"
    >
      <v-avatar
          dark
          class="white primary--text mr-2"
          size="36"
      >
        {{ index + 1 }}
      </v-avatar>
      <v-list-item-content>
        <v-list-item-title>{{ step.name }}</v-list-item-title>
        <v-list-item-subtitle>
          <v-dialog
              ref="dialogDate"
              v-model="modalDate"
              :return-value.sync="updateDate"
              persistent
              width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <span
                  v-bind="attrs"
                  v-on="on"
                  class="clickable-dashed"
              >{{ updateDate }}</span>
            </template>
            <v-date-picker
                v-model="updateDate"
                scrollable
            >
              <v-spacer></v-spacer>
              <v-btn
                  color="primary"
                  text
                  @click="modalDate = false"
              >
                Cancel
              </v-btn>
              <v-btn
                  color="primary"
                  text
                  @click="$refs.dialogDate.save(updateDate)"
              >
                OK
              </v-btn>
            </v-date-picker>
          </v-dialog>
          &nbsp;
          <v-dialog
              ref="dialogTime"
              v-model="modalTime"
              :return-value.sync="updateTime"
              persistent
              width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <span
                  v-bind="attrs"
                  v-on="on"
                  class="clickable-dashed"
              >{{ updateTime }}</span>
            </template>
            <v-time-picker
                v-if="modalTime"
                v-model="updateTime"
                full-width
            >
              <v-spacer></v-spacer>
              <v-btn
                  color="primary"
                  text
                  @click="modalTime = false"
              >
                Cancel
              </v-btn>
              <v-btn
                  color="primary"
                  text
                  @click="$refs.dialogTime.save(updateTime)"
              >
                OK
              </v-btn>
            </v-time-picker>
          </v-dialog>
        </v-list-item-subtitle>
      </v-list-item-content>
      <v-list-item-action>
        <v-checkbox
            v-model="step.complete"
            :disabled="step.error"
            @click.native="change()"
            dark
        ></v-checkbox>
      </v-list-item-action>
    </v-list-item>
  </v-card>
</template>
<script>
import moment from 'moment'

export default {
  components: {},
  name: 'AdminStepCard',
  props: {
    step: Object,
    index: Number
  },
  data() {
    return {
      updateDate: '',
      updateTime: '',
      modalDate: false,
      modalTime: false,
    }
  },
  computed: {},
  watch: {
    updateDate(newDate) {
      const newTime = this.updateTime || moment().format('HH:mm:ss')
      this.step.updated = newDate + ' ' + newTime
      this.$emit('change')
    },
    updateTime(newTime) {
      const newDate = this.updateDate || moment().format('YYYY-MM-DD')
      this.step.updated = newDate + ' ' + newTime
      this.$emit('change')
    }
  },
  methods: {
    change() {
      let updateMoment = moment()
      if (this.step.complete) {
        this.updateDate = updateMoment.format('YYYY-MM-DD')
        this.updateTime = updateMoment.format('HH:mm:ss')
        this.step.updated = updateMoment.format('YYYY-MM-DD HH:mm:ss')
      } else {
        this.updateDate = ''
        this.updateTime = ''
        this.step.updated = null
      }
      this.$emit('change')
    }
  },
  mounted() {
    if ('updated' in this.step && this.step.updated !== null) {
      this.updateDate = moment(this.step.updated).format('YYYY-MM-DD')
      this.updateTime = moment(this.step.updated).format('HH:mm:ss')
    }
  }
}
</script>
<style lang="scss" rel="stylesheet/scss" scoped>
.clickable-dashed {
  display: inline-block;
  border-bottom: 1px dashed #fff;
}
</style>